import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { apiMiddlewares, apiReducers } from '@app/api/apis';
import { baseApi } from '@app/api/baseApi';
import { publicBaseApi } from '@app/api/publicBaseApi';
import errorReducer from './errorSlice';
const rootReducer = combineReducers(Object.assign(Object.assign({}, apiReducers), { error: errorReducer }));
export const store = configureStore({
    reducer: rootReducer,
    middleware: (gDM) => gDM().concat(...apiMiddlewares),
});
export function setupStore(preloadedState) {
    return configureStore({
        reducer: rootReducer,
        middleware: (gDM) => gDM().concat(...apiMiddlewares),
        preloadedState,
    });
}
